import { combineReducers } from 'redux'

import deviceReducer from './deviceReducer'
import editorReducer from './editorReducer'
import currentPresetReducer from './currentPresetReducer'
import preferencesReducer from './preferencesReducer'

const KBoardApp = combineReducers({
  device: deviceReducer,
  editor: editorReducer,
  currentPreset: currentPresetReducer,
  editorPreferences: preferencesReducer
})

export default KBoardApp
